import { DEFAULT_LOCALE, resources } from '@veriverse/i18n';
import { SUPPORTED_LOCALES, type Locale } from '@veriverse/shared';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const STORAGE_KEY = 'veriverse.locale';

function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

/** Stored choice → browser language → English. Storage may be unavailable (private mode). */
function initialLocale(): Locale {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isLocale(stored)) return stored;
  } catch {
    /* storage blocked: fall through */
  }
  const browser = navigator.language.slice(0, 2);
  return isLocale(browser) ? browser : DEFAULT_LOCALE;
}

export function changeLocale(locale: Locale): void {
  void i18next.changeLanguage(locale);
  document.documentElement.lang = locale;
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    /* non-essential preference */
  }
}

void i18next.use(initReactI18next).init({
  resources,
  lng: initialLocale(),
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false }, // React already escapes
});
document.documentElement.lang = i18next.language;

export default i18next;
